import type { ComponentProps, ReactNode } from "react";
import { hueFor, initialOf } from "../ui";
import { Drawer } from "./Kit";
import "../adminkit.css";

/*
 * Parts the prototype's core (v2.20 core.js) has and Kit.tsx does not yet, for
 * 价目表, 团队 and 设置 (adminkit.css, every class ak-): Face its Avatar, Ring
 * its Ring. To be folded into the kit when the pages come together, as its
 * Drawer (Sheet) and toast have been.
 */

/**
 * The kit's drawer (Kit.tsx Drawer) for a form that needs room: 加同事, a role's permissions, 改新加坡价钱. Under
 * the name ak-sheet, for what these pages draw inside it: outside the pages (.lz), so their bare buttons need the
 * console's blanket look taken off there (adminkit.css).
 */
export function Sheet(props: Omit<ComponentProps<typeof Drawer>, "className">) {
  return <Drawer {...props} className="ak-sheet" />;
}

/** The line at the top for a moment is the kit's now (every page says one); kept here for the pages that import it from here. */
export { toast } from "./Kit";

/** A colleague's face: their initial on the colour of their name (the account button's), a dot while on the console. */
export function Face({ name, email, size = 40, online }: { name: string; email: string; size?: number; online?: boolean }) {
  return (
    <span className="ak-face" style={{ width: size, height: size, fontSize: Math.round(size * 0.4), background: hueFor(name || email) }} aria-hidden="true">
      {initialOf(name || email)}
      {online && <i className="ak-on" />}
    </span>
  );
}

/** How much of something is left, as a ring; what it says goes in the middle. */
export function Ring({ value, size = 30, stroke = 4, color = "var(--warn)", children }: { value: number; size?: number; stroke?: number; color?: string; children?: ReactNode }) {
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  return (
    <span className="ak-ring" style={{ width: size, height: size }}>
      <svg width={size} height={size} aria-hidden="true">
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="var(--sunk)" strokeWidth={stroke} />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          stroke={color}
          strokeWidth={stroke}
          strokeLinecap="round"
          // A new value sweeps there in 1.2 s, as the prototype's Ring (core.js 446), on the dash's offset.
          strokeDasharray={`${c} ${c}`}
          strokeDashoffset={c * (1 - Math.max(0, Math.min(1, value)))}
          className="ak-ring-v"
        />
      </svg>
      {children && <span className="ak-ring-in">{children}</span>}
    </span>
  );
}
